/**
 * Dark palette for pages opted into DarkPageScope.
 *
 * Values mirror the Intelligence Suite palette (containers/Intelligence/theme/tokens.ts) so the two
 * dark surfaces in the product read as one system. They are duplicated rather than imported because
 * that file is owned by PLA-8815 and its tokens carry Intelligence-specific type roles we do not
 * want here. PLA-8844.
 */
export const darkTokens = {
  // Surfaces. Note the design inverts the usual elevation direction: deeper surfaces go DARKER,
  // page #0A0F1C -> card #101830 -> panel-in-modal #0D1428.
  'bg-page': '#0A0F1C',
  // The Orbit page fill, behind a module builder hosted in the Orbit modal.
  'bg-builder': '#05090F',
  'surface-card': '#101830',
  'surface-raised': '#0D1428',
  // Not drawn anywhere in the design; retained for chips, inputs and button states, which the
  // frames do not cover. These are ours, not the design's.
  'surface-hover': '#1A2237',
  'surface-selected': '#17305C',
  'border-subtle': '#212D4B',
  'border-strong': '#2A405F',

  // Text
  'text-title': '#F5F7FF',
  'text-primary': '#F5F7FB',
  'text-secondary': '#AEBBD0',
  'text-muted': '#64709A',
  'text-placeholder': '#757575',
  'on-accent': '#FFFFFF',

  // Accents
  accent: '#4F46E5',
  'accent-hover': '#6C63F0',
  link: '#268AFF',
  'link-hover': '#5AA6FF',
  success: '#1EB980',
  industry: '#16834F',
  warning: '#F3B95F',

  // Status chips. StatusTag paints its own light-mode fills inline (#10d994 success, #c23a34
  // failure), which land as vivid slabs on a dark table. These are the Intelligence palette's dark
  // semantics - --is-negative and the two tint backgrounds - mirrored under the same policy as the
  // rest of this file. PLA-8844.
  danger: '#EE6475',
  'tint-positive-bg': '#15382D',
  'tint-negative-bg': '#3A1620',
  // Third member of the tint pair above, at the same depth, for the amber warning slabs antd and
  // our own panels draw as #fffbe6. PLA-8844.
  'tint-warning-bg': '#3A2E13'
};

export const darkTokenDeclarations = Object.entries(darkTokens)
  .map(([token, value]) => `--dk-${token}: ${value};`)
  .join('\n');
